export default __webpack_public_path__ + "static/media/custom-banner-default.1a7c3b18.jpg";